// eslint-disable-next-line import/prefer-default-export
export const SET_SERVICE_LIST = 'SET_SERVICE_LIST';
export const SET_SERVICE_INFO = 'SET_SERVICE_INFO';
